import { render, staticRenderFns } from "./ManageRequestTos.vue?vue&type=template&id=b19bfad6"
import script from "./ManageRequestTos.vue?vue&type=script&lang=js"
export * from "./ManageRequestTos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports